export default function ToggleButton({
  label,
  checked,
  onChange
}) {
  return (
    <button
      type="button"
      className={`toggle ${checked ? "on" : ""}`}
      onClick={() => onChange(!checked)}
      aria-pressed={checked}>
      <span className="toggle-track">
        <span className="toggle-thumb"></span>
      </span>

      <span className="toggle-label">
        {label}
      </span>
    </button>
  );
}